import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { Box, Button, CircularProgress, CssBaseline, Link, TextField, Typography } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import NDReferralHeader from "../../components/shared/ndreferralheader";
import { getApiUrl } from "../../services/api_service";
import MyTimer from "../../components/shared/mytimer";
import { useAuth } from "../../contexts/AuthContext";
import AccessLocalStorage from "../../services/localStorage";
import Footer from "../../components/shared/footer";
import { bodyBg, darkcolor, footerContainer, fullHeight, pcolor, rcolor, whitecolor } from "../../style2";

export default function ReferrerLogin() {
    const { orgCode } = useParams();

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState('');
    const [error, setError] = useState('');
    const [redirect, setRedirect] = useState('');
    const [showValidateOTP, setShowValidateOTP] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(false);

    const generateOtpFunc = () => {
        setLoading(true);
        fetch(`${getApiUrl()}/ReferrerAccount/generateotp?email=${email}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.status === 200) {
                setShowValidateOTP(true);
            }
            else if (response.status === 404) {
                setError("Please register to refer a child.")
            }
            else {
                response.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err => {
                    console.log(err);
                    setError("Unable to process request.");
                })
            }
        }).catch(err => {
            console.log(err);
            setError("Unable to contact server.");
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                setLoggedIn(true);
                setRedirect(`/referral/screenprocess/${orgCode}`);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    if (redirect !== "")
        return <Redirect to={redirect} />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader date={Date.UTC()} isLoggedIn={isLoggedIn} orgCode={orgCode} logo="../../Logo_Option_1.svg" />

            {showValidateOTP ?
                <Box sx={{ maxWidth: "800px", padding: "5rem 10rem", margin: "0 auto" }}>
                    <ValidateReferralOTP email={email} redirect={`/referral/screenprocess/${orgCode}`} /> </Box> :
                <Box sx={{ width: "50%", padding: "4rem 8rem", margin: "0 auto" }}>
                    <Typography sx={{ color: pcolor, fontSize: "1.2rem", marginBottom: "15px" }}>
                        Log in to refer a patient or Answer questionnaires of existing referrals.</Typography>
                    <form onSubmit={(e) => {
                        e.preventDefault(); generateOtpFunc();
                    }}>
                        <Box mb={1}>
                            <label style={{ color: pcolor, display: "block", fontWeight: "bold", fontSize: "1.1rem", marginBottom: "10px" }}>School / SENCO’S Email *</label>
                            <TextField inputProps={{ maxLength: "150", type: "email" }} style={{ border: `1px solid ${pcolor}`, borderRadius: 5, width: "100%" }} variant="outlined" required={true} label="" value={email} onChange={(e) => {
                                setEmail(e.target.value);
                            }} />
                        </Box>
                        <Box py={2} textAlign="center">
                            <button type="submit" disabled={loading} title="Generate One Time Passcode"
                                style={{
                                    border: `1px solid ${rcolor}`, background: rcolor, color: whitecolor, fontSize: "1.5rem",
                                    height: "50px", width: "100%", borderRadius: 2
                                }}>{loading ? <CircularProgress size={20} /> : null}  Generate OTP</button>
                        </Box>
                        {error !== "" ? <Box mt={1} mb={2} style={{ color: rcolor, fontSize: "1.1rem", textAlign: "center" }}>{error}</Box> : null}
                    </form>
                    <Box sx={{ textAlign: "center", fontSize: "1.20rem", margin: "15px 0px" }}>
                        <Button type="button" style={{
                            padding: "5px",
                            textTransform: 'none',
                            color: pcolor,
                            fontSize: "1.2rem",
                            '&:hover': {
                                textDecoration: 'underline',
                                backgroundColor: 'transparent',
                            },
                        }}
                            onClick={() => { setRedirect(`/referral/register/${orgCode}`) }}>Register as Referrer</Button>
                    </Box>

                    <Box sx={{ textAlign: "center", fontSize: "1.20rem", margin: "15px 0px" }}>
                        Problems signing in? <Link href="mailto:contact@enrichmycare.com" target="_blank" rel="noreferrer">Contact Us</Link>
                    </Box>
                </Box>}
            <Box sx={footerContainer}>
                <Footer />
            </Box>
        </Box>;
}

export function ValidateReferralOTP(props) {
    const timerseconds = 60;
    const time = new Date();
    time.setSeconds(time.getSeconds() + timerseconds);
    const [otp, setOTP] = useState("");
    const [redirect, setRedirect] = useState('');
    const [timer, setTimer] = useState(time);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [allowResend, setAllowResend] = useState(false);
    const ls = new AccessLocalStorage();

    let auth = useAuth();


    const acceptAndValidateOTP = () => {
        setLoading(true);
        setError('');
        setSuccess('');
        var fd = new FormData();
        fd.append("email", props.email);
        fd.append("otp", otp);
        fetch(getApiUrl() + "/ReferrerAccount/ValidateOTP", {
            method: "post", headers: {},
            body: fd
        }).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    auth.setAuthData(data);
                    setSuccess("Login successfull.");
                    setRedirect(props.redirect);
                });
            } else {
                resp.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err => {
                    setError("Unable to validate passcode.");
                    console.log(err);
                });

            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    const sendingOTPAllowed = () => {
        if (ls.getReferralOTPSentCount() >= 5) {
            let b = ls.hoursPassedSinceLastReferralOTPSent() >= 0 && ls.hoursPassedSinceLastReferralOTPSent() <= 5;
            return !b;
        }
        return true;
    }

    const resendOTP = () => {
        if (!sendingOTPAllowed()) {
            setError('You have exhausted all attempts, please try after two hours.');
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(getApiUrl() + "/ReferrerAccount/generateotp?email=" + props.email, { method: "get" }).then(resp => {
            if (resp.status === 200) {
                setSuccess('A passcode has been sent to your registered email.')

                setAllowResend(false);
                let t = new Date();
                t.setSeconds(t.getSeconds() + timerseconds);
                setTimer(t);
                ls.setReferralOTPSentCount(ls.getReferralOTPSentCount() + 1);
            } else {
                resp.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err2 => {
                    setError('Unable to generate passcode.');
                    console.log(err2);
                });
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }


    const renderError = () => {
        if (error !== "")
            return <Box m={1} style={{ textAlign: "center", color: "red" }}>{error}</Box>;
        else return null;
    }

    const renderSuccess = () => {
        if (success !== "")
            return <Box m={1} style={{ textAlign: "center", color: "green" }}>{success}</Box>;
        else return null;
    }

    const renderTimer = () => {
        if (timer != null) {
            return <Box textAlign={"center"} p={2} pt={0}>Resend code in <span style={{
                backgroundColor: darkcolor, borderRadius: "5px", color: whitecolor, fontWeight: "bold", padding: "3px"
            }}><MyTimer expiryTimestamp={timer} onExpired={() => {
                setAllowResend(true);
                setTimer(null);
            }} /></span>
            </Box>;
        } else return renderResentLink();
    }

    const renderResentLink = () => {
        if (!allowResend) return null;

        if (!sendingOTPAllowed()) {
            return <Box mb={3} p={2} style={{ textAlign: "center" }}>You have exhausted all attempts, try after 2 hours.</Box>;
        }

        return <Box mb={3} p={2} style={{ textAlign: "center" }}>
            <Button type="button" disabled={loading} sx={{ color: "#4bc0a9", padding:"10px" }} onClick={resendOTP}>Resend OTP</Button></Box>;
    }

    if (redirect !== "")
        return <Redirect to={redirect} />;
    else
        return <Box sx={{ background: whitecolor, padding: "1rem", borderRadius: "10px" }} >
            <h3 style={{ fontWeight: "400", textAlign: "center", fontSize: "1.1rem" }} p={3}>A passcode has been sent to your registered email address.</h3>
            <Box style={{ fontWeight: "400", textAlign: "center", margin: "20px 0px", fontSize: "1.1rem" }}>Please enter the code below</Box>
            <form onSubmit={(e) => { e.preventDefault(); acceptAndValidateOTP(); }}>
                <Box pt={2} style={{ margin: "0 auto", width: "400px" }}>
                    <input type="text"

                        required
                        maxLength={6}
                        value={otp} style={{
                            border: "1px solid #989898",
                            borderRadius: "9px", fontSize: "2rem", width: "100%", textAlign: "center", padding: "8px", backgroundColor: "#f9f9f9"
                        }}
                        onChange={(e) => { setOTP(e.target.value); }}
                    />
                </Box>
                {renderError()}
                {renderSuccess()}
                <Box style={{ textAlign: "center", padding: "20px 0px", margin: "0 auto", width: "400px" }}>
                    <Button type="submit" variant={otp.length === 6 ? "contained" : "outlined"}
                        disabled={otp.length < 6} style={{
                            color: whitecolor,
                            background: "#4bc0a9",
                            borderColor: "#4bc0a9",
                            borderRadius: "9px",
                            minHeight: "46px",
                            boxShadow: "none ", padding: "0px 10px",
                        }}>
                        {loading ? <CircularProgress color="inherit" /> : "Validate"}
                    </Button>
                </Box>

                <div style={{ marginTop: "35px", fontSize: "16px" }}>
                    {renderTimer()}
                </div>
                <div style={{ marginTop: "20px", marginRight: "20px", textAlign: "right", fontSize: "16px" }}>
                    <span style={{ color: darkcolor }}>Attempts left:</span> <span style={{
                        borderRadius: "5px", padding: "3px 5px", color: "#fff",
                        background: "#4bc0a9"
                    }}>{5 - ls.getReferralOTPSentCount()}</span>
                </div>
            </form>
        </Box>;
}